import { render, staticRenderFns } from "./editBaseSet.vue?vue&type=template&id=fd1b147a&scoped=true&"
import script from "./editBaseSet.vue?vue&type=script&lang=js&"
export * from "./editBaseSet.vue?vue&type=script&lang=js&"
import style0 from "./editBaseSet.vue?vue&type=style&index=0&id=fd1b147a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd1b147a",
  null
  
)

export default component.exports